/*
 * Layout for example modal.  Layout has regions for the example editor and the strength gauge
 */

define([
  "marionette",
  "modules/topicsSplit/topic/topicExampleModal/template/topicExampleModalTemplate.html",
], function (Marionette, TopicExampleModalTemplate) {
  var TopicExampleModalView = {};

  TopicExampleModalView.topicExampleModalLayout = Marionette.Layout.extend({
    template: TopicExampleModalTemplate,
    disableDoneButton: function () {
      this.$el.find("#doneButton").prop("disabled", true);
    },
    enableDoneButton: function () {
      this.$el.find("#doneButton").prop("disabled", false);
    },
    regions: {
      locale: "#locale",
      editor: "#editor",
      gauge: "#gauge",
      translation: "#translation",
      suppression: "#suppression",
    },
    triggers: {
      "click #doneButton": "done",
      "click #cancelButton": "cancel",
    },
  });

  return TopicExampleModalView;
});
